import { StyleDc } from "@evergis/api";
import { RangeValue } from "@evergis/ui";

import { castResolutionToScale, castScaleToResolution } from "../scale";
import { extractStyle, packStyle } from "../symbol/compositeSymbol";
import { ClassificationManager } from "./ClassificationManager";
import { Style } from "../../../ducks/style/style";

export class StyleProxy {
  public classificationManager: ClassificationManager;

  private readonly style: Style;

  private readonly defaultScaleRange: RangeValue;

  constructor(style?: StyleDc | null, defaultScaleRange?: RangeValue, resolution?: number) {
    this.style = extractStyle(style || {});
    this.defaultScaleRange = defaultScaleRange;
    this.classificationManager = new ClassificationManager(this.style, resolution);
  }

  public serialize() {
    return packStyle(this.style);
  }

  public hasRasters() {
    return !!(this.style.raster || (this.style.children || []).some(style => style.raster));
  }

  get symbol() {
    return this.style.symbol;
  }

  get raster() {
    return this.style.raster;
  }

  get label() {
    return this.style.label;
  }

  get children() {
    return this.style.children;
  }

  get title() {
    return this.style.title;
  }

  get condition() {
    return this.style.condition;
  }

  get ignoreLabel() {
    return this.style.ignoreLabel;
  }

  set resolution(scale: Nullable<RangeValue>) {
    if (scale) {
      const [minResolution, maxResolution] = castScaleToResolution(scale);

      this.style.minResolution = minResolution;
      this.style.maxResolution = maxResolution;
    }
  }

  get resolution(): Nullable<RangeValue> {
    const { minResolution, maxResolution } = this.style;

    return minResolution === void 0 || maxResolution === void 0 ? null : [minResolution, maxResolution];
  }

  get scale(): RangeValue {
    return castResolutionToScale(this.style, this.defaultScaleRange);
  }
}
